import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id DD3492E1-1F83-4E41-8BA9-9E6A1380D235
 * name application
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application.svg
 * tags
 */
export const ApplicationIcon = createSvgIcon(<><path d="M21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V4C23 2.9 22.1 2 21 2M21 7H3V4H21V7Z" /></>, 'ApplicationIcon');
export default ApplicationIcon